/**
 * API Client barrel — re-exports from core and domain modules.
 * Import from '../api/client' (or '../../api/client') for backward compatibility.
 */

// Core
export {
    API_BASE,
    ONBOARDIX_TOKEN_KEY,
    getToken,
    removeToken,
    getCachedUser,
    setCachedUser,
    apiFetch,
    apiFetchRaw,
    apiHealth,
    fetchWithFallback,
} from './core'

// Auth & users
export {
    apiLogin,
    apiTelegramWebAppLogin,
    apiImpersonate,
    apiViewAsTargets,
    apiViewAs,
    apiStopImpersonating,
    apiGetMe,
    apiGetCapabilities,
    apiGetRolePermissions,
    apiUpdateRolePermissions,
    apiCreateRole,
    apiUpdateRoleMeta,
    apiDeleteRole,
    apiCleanupDuplicateRoles,
    apiGetRoleSuggestedModules,
    apiSyncUserModulesFromRole,
    apiGetUserPermissions,
    apiUpdateUserPermissions,
    apiSyncAccounts,
} from './auth'
export {
    apiListUsers,
    apiCreateUser,
    apiUpdateUser,
    apiDeleteUser,
    apiSeedEmployeeAccounts,
    apiGetCredentials,
    apiReseedLogins,
    apiResetPassword,
    apiCreateInvite,
    apiCreateInvitesBulk,
    apiListPasswordResetRequests,
    apiResolvePasswordResetRequest,
} from './users'

// Domain objects
export { testSessions } from './testSessions'
export { teamInsights, morningDebrief, myCalibration } from './teamInsights'
export { learningAgenda } from './learningAgenda'
export { workflow } from './workflow'
export { flags } from './flags'
export { org } from './org'
export { employees } from './employees'
export { startCenter } from './startCenter'
export { candidates } from './candidates'
export { applications } from './applications'
export { vacancies } from './vacancies'
export { offerSigning } from './offers'
export { offers } from './offers'
export { erp } from './erp'
export { erpAdvanced } from './erpAdvanced'
export { erpPro } from './erpPro'
export { idp } from './idp'
export { itAdmin } from './itAdmin'
export { hireOnboarding } from './hireOnboarding'
export { hrDashboard } from './hrDashboard'
export { training } from './training'
export { assessments } from './assessments'
export { testAdmin } from './testAdmin'

// Knowledge, docs, analytics, wiki, contractors, files, onboarding
export { knowledgeApi } from './knowledge'
export { docRecords } from './docRecords'
export { analytics } from './analytics'
export { hrIntel } from './hrIntel'
export { wiki } from './wiki'
export { contractors } from './contractors'
export { files } from './files'
export { onboarding } from './onboarding'
export { offerApprovals } from './offerApprovals'
